import React from "react";

const COIN_IMAGE_URL =
  "https://d135lw6vh1h84k.cloudfront.net/assets/images/coins.png";

const Coins = (props) => {
  return (
    <div className="coins">
      <div className="coin-number">{props.coins}</div>
      <div className="coin-image">
        <img src={COIN_IMAGE_URL} alt="coin" />
      </div>
    </div>
  );
};

export default Coins;



// WEBPACK FOOTER //
// ./src/coins/Coins.jsx